import type { CouponMiniEntity } from '@/features/coupons/domain/entities/CouponMiniEntity'
import type { PrizeType } from '../enums/PrizeType'
import type { PrizeTranslationEntity } from './PrizeTranslationEntity'

export class PrizeEntity {
  id?: number
  type?: PrizeType
  externalId?: string | null
  externalName?: string | null
  translations?: Array<PrizeTranslationEntity> | null
  weight?: number | null
  coupon?: CouponMiniEntity
  imageUrl?: string | null
  color?: string | null
}
